import type { ICorporateDocumentsTabs } from "@/domains/investor/corporate-governance/corporate-documents/types/Document.tabs.types"

export const useTabs = () => {
  const { t } = useI18n()
  const documentsTabs = ref<ICorporateDocumentsTabs[]>(
    [
      {
        label: t('investor.corporateGovernance.corporateDocuments.tabs[0].label'),
        mode: 'all',
      },
      {
        label: t('investor.corporateGovernance.corporateDocuments.tabs[1].label'),
        fileListId: 'corporate-document-statutes',
      },
      {
        label: t('investor.corporateGovernance.corporateDocuments.tabs[2].label'),
        fileListId: 'corporate-document-laws',
      },
      {
        label: t('investor.corporateGovernance.corporateDocuments.tabs[3].label'),
        fileListId: 'corporate-document-polices',
      },
      {
        label: t('investor.corporateGovernance.corporateDocuments.tabs[4].label'),
        fileListId: 'corporate-document-other',
      },
    ],
  )

  return {
    documentsTabs
  }
}